import PageHeaderBlock from '@layouts/PageHeaderBlock';

const Blogs: React.FC = () => {
  return (
    <>
      <PageHeaderBlock
        title="2022 software development trends explained with benefits"
        replaceDefaultTitle="2022 software development trends "
      />
    </>
  );
};

Blogs.displayName = 'Blogs';

export default Blogs;
